/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const LTIIcon = /*#__PURE__*/ createSvgIcon(
  'LTIIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.167 17.5c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 01-.49-1.177v-1.666c0-.236.08-.434.24-.594.16-.16.357-.24.593-.24s.434.08.594.24c.16.16.24.358.24.594v1.666h11.666v-10H4.167V7.5c0 .236-.08.434-.24.594a.806.806 0 01-.594.24.806.806 0 01-.593-.24.806.806 0 01-.24-.594V4.167c0-.459.163-.851.49-1.177.326-.327.718-.49 1.177-.49h11.666c.459 0 .851.163 1.177.49.327.326.49.718.49 1.177v11.666c0 .459-.163.851-.49 1.177-.326.327-.718.49-1.177.49H4.167zm5.979-5.833H3.333a.806.806 0 01-.593-.24.806.806 0 01-.24-.594c0-.236.08-.434.24-.593.16-.16.357-.24.593-.24h6.813L9 8.833a.814.814 0 01-.24-.573.776.776 0 01.24-.593.79.79 0 01.583-.23.79.79 0 01.584.23l2.583 2.583a.8.8 0 01.25.583.8.8 0 01-.25.584L10.167 14a.815.815 0 01-.573.24A.776.776 0 019 14a.79.79 0 01-.23-.583.79.79 0 01.23-.584l1.146-1.166z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default LTIIcon;
